var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayer = function SvgLayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.999a1 1 0 0 0-.516-.874l-9.022-5a1 1 0 0 0-.968 0l-8.978 4.96a1 1 0 0 0-.003 1.748l9.022 5.04a1 1 0 0 0 .973.001l8.978-5A1 1 0 0 0 22 7.999m-9.977 3.855L5.06 7.965l6.917-3.822 6.964 3.859z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.517 11.126-8.515 4.73-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .97 0l9-5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20.517 15.126-8.515 4.73-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .97 0l9-5z"
  })));
};
export default SvgLayer;